import { render, staticRenderFns } from "./Assist.vue?vue&type=template&id=55d75a79&scoped=true"
import script from "./Assist.vue?vue&type=script&lang=js"
export * from "./Assist.vue?vue&type=script&lang=js"
import style0 from "./Assist.vue?vue&type=style&index=0&id=55d75a79&prod&lang=css"
import style1 from "./Assist.vue?vue&type=style&index=1&id=55d75a79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d75a79",
  null
  
)

export default component.exports